import { ComponentFactoryResolver, Inject, Injectable } from '@angular/core';
import { CmsViewDirectiveComponent } from './cmsviewdirective.component';
declare var $: any;

export interface CmsViewDirectiveInterface {
    clickEvent(e): void;
}

@Injectable()
export class CmsViewDirectiveService {
    factoryResolver: any;
    rootViewContainer: any;
    // componentRef: ComponentRef;

    constructor(@Inject(ComponentFactoryResolver) factoryResolver) {
        this.factoryResolver = factoryResolver
    }

    setRootViewContainerRef(viewContainerRef) {
        this.rootViewContainer = viewContainerRef
    }

    addDynamicComponent(templateId) {
        const factory = this.factoryResolver.resolveComponentFactory(CmsViewDirectiveComponent);
        const component = factory.create(this.rootViewContainer.parentInjector);
        // component._component.templateId = templateId;
        component.instance.templateId = templateId;
        this.rootViewContainer.insert(component.hostView);

        component.instance.outputEventHere.subscribe(data => {
            if (data) {                
                component.destroy();
            }
        });
        console.log("inside add compoentn");
    }

    removeDynamicComponent() {
        const factory = this.factoryResolver.resolveComponentFactory(CmsViewDirectiveComponent);
        const component = factory.create(this.rootViewContainer.parentInjector);
        component.destroy();
        console.log("inside destroy compoentn");
    }
}